const config = {
  apiURL: '/api',
  defaultLang: 'de'
};

export class AppConfig {
  apiURL: string;
  defaultLang: string;

  constructor () {
    this.apiURL = config.apiURL || '';
    this.defaultLang = config.defaultLang || '';
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/app.config.ts